import resolve from 'ioc/resolve'
import AutoQueryConfig from 'servicestack/auto-query/auto-query.config'
import basicController from 'servicestack/basic.controller.properties'

class AutoQueryBreadcrumbsController {
    constructor() {
        basicController(this)
    }
    isOneUp(){
        return resolve('$state').current.name === 'shop.product'; // hack
    }
    go(nav){
        if(this.isOneUp()) resolve('$state').transitionTo('shop.multi-view'); // TODO: hack
        nav.backToHere();
    }
}

export default AutoQueryBreadcrumbsController
